module.exports = {"data":{"person":{"edges":[{"node":{"id":"/Users/alex/Sites/cv/src/markdown/person.md absPath of file >>> MarkdownRemark","frontmatter":{"position":200,"title":"Person","links":[{"href":"mailto:jenteralex@gmail.com?subject=Hey, nice CV!","text":"Email"},{"href":"https://github.com/AlexJenter","text":"Github"},{"href":"https://www.linkedin.com/in/jenteralex/","text":"LinkedIn"}]},"html":"<p>Web developer with a background in design</p>"}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects.json
// module id = 324
// module chunks = 97786326051841